import { render, staticRenderFns } from "./GroupProfileView.vue?vue&type=template&id=2ea9dd9c&scoped=true&"
import script from "./GroupProfileView.vue?vue&type=script&lang=js&"
export * from "./GroupProfileView.vue?vue&type=script&lang=js&"
import style0 from "./GroupProfileView.vue?vue&type=style&index=0&id=2ea9dd9c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9dd9c",
  null
  
)

export default component.exports